import normalizeText from '@/lib/normalizeWhitespaceText.js';

const setThreadAutomationActive = ({ map, threadId, active }) => {
  const normalizedThreadId = normalizeText(threadId);

  if (!normalizedThreadId) {
    return;
  }

  map[normalizedThreadId] = active === true;
};

const buildAutomationActiveByThreadId = ({ scheduleItems = [], triggerItems = [], workflowItems = [] } = {}) => {
  const automationActiveByThreadId = {};

  for (const schedule of Array.isArray(scheduleItems) ? scheduleItems : []) {
    setThreadAutomationActive({
      map: automationActiveByThreadId,
      threadId: schedule?.threadId || schedule?.id,
      active: schedule?.active
    });
  }

  for (const trigger of Array.isArray(triggerItems) ? triggerItems : []) {
    setThreadAutomationActive({
      map: automationActiveByThreadId,
      threadId: trigger?.threadId || trigger?.id,
      active: trigger?.active
    });
  }

  for (const workflowItem of Array.isArray(workflowItems) ? workflowItems : []) {
    if (!workflowItem?.threadId) {
      continue;
    }

    setThreadAutomationActive({
      map: automationActiveByThreadId,
      threadId: workflowItem.threadId,
      active: workflowItem.active
    });
  }

  return automationActiveByThreadId;
};

export default buildAutomationActiveByThreadId;
